import React from 'react';
import { string, number, bool, oneOf } from 'prop-types';
import { useLandingProduct } from 'hooks';
import classnames from 'classnames';
import { productShape } from 'shapes';
import ProductCard from 'modules/ProductCardContainer/ProductCardContainer';
import { PRODUCT_CARD_MODE } from 'components/ProductCard/ProductCard.utils';
import OldProduct from '../OldProduct/Product';

export default function PromotedProduct({
    className,
    value,
    redesignedCard,
    mode,
    ...otherProps
}) {
    const [landingProductModelId] = useLandingProduct();
    const isLandingProduct =
        value.model_id === parseInt(landingProductModelId, 10);
    const rootClassnames = classnames('product-top-sale', className);
    const ProductCardComponent = redesignedCard ? ProductCard : OldProduct;

    return (
        <ProductCardComponent
            className={rootClassnames}
            product={value}
            mode={
                mode === PRODUCT_CARD_MODE.LIST_SPEC
                    ? PRODUCT_CARD_MODE.LIST_SPEC
                    : PRODUCT_CARD_MODE.LIST
            }
            dataPosition={0}
            unableRedirectToModels={isLandingProduct}
            hideSpecs={isLandingProduct}
            useGenericTitle={isLandingProduct}
            {...otherProps}
        />
    );
}

PromotedProduct.propTypes = {
    className: string,
    value: productShape.isRequired,
    categoryId: number.isRequired,
    redesignedCard: bool,
    mode: oneOf([
        PRODUCT_CARD_MODE.GRID,
        PRODUCT_CARD_MODE.GRID_VISUAL,
        PRODUCT_CARD_MODE.LIST_SPEC,
        PRODUCT_CARD_MODE.LIST,
    ]),
};

PromotedProduct.defaultProps = {
    className: '',
    redesignedCard: false,
    mode: PRODUCT_CARD_MODE.LIST,
};
